import React from 'react'
import { useSelector } from 'react-redux'

import { Wrapper, TemplateRoot, TemplateItem } from './Layout'
import { getNote } from 'data/notes/selectors'

export default React.memo(function TemplatesBreadcrumb({ templateId }) {
  const activeNote = useSelector(state => getNote(state, templateId))
  if (!activeNote) {
    return false
  }
  return (
    <Wrapper>
      <TemplateRoot />
      {activeNote && <TemplateItem note={activeNote} />}
    </Wrapper>
  )
})
